import { render, staticRenderFns } from "./customerDesk.vue?vue&type=template&id=a26709f4&scoped=true&"
import script from "./customerDesk.vue?vue&type=script&lang=js&"
export * from "./customerDesk.vue?vue&type=script&lang=js&"
import style0 from "./customerDesk.vue?vue&type=style&index=0&id=a26709f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26709f4",
  null
  
)

export default component.exports